import Venue from 'models/venue';
export const GOT_VENUE = 'got-venue';
const gotVenue = ({ venue }) => ({
  type: GOT_VENUE,
  payload: {
    venue: new Venue(venue),
  },
});
export default gotVenue;
